import { ColDef, GridOptions } from "ag-grid-community";


export const salesHeaders: ColDef<any, any>[] =
[
    {headerName: "Stock Name", field: "SALES_STOCK_NAME", enableRowGroup: true, flex: 2, minWidth:300},
    {headerName: "Item Description", field: "SALES_ITEM_DESC", enableRowGroup: true, flex: 2, minWidth:300},    
    {headerName: "Day(Distinct)", field: "DAY_DISTINCT", enableRowGroup: true, flex: 1},
    {headerName: "Created", field: "STOCK_CREATED", enableRowGroup: true, flex: 1},
   
    {headerName: "COGS", field: "SALES_COGS", type: 'rightAligned', cellRendererParams: { align: "right" }, aggFunc: "sum ", cellRendererSelector: (_) => {
        return { component: "priceCellRenderer", enableRowGroup: true }
    }}, 
    {headerName: "Day", field: "DAY", enableRowGroup: true, flex: 1},
    {headerName: "Department", field: "SALES_DEPARTMENT", enableRowGroup: true},
    {headerName: "Discount", field: "SALES_DISCOUNT", type: 'rightAligned',  cellRendererParams: { align: "right" }, aggFunc: "sum ", cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},
    {headerName: "Govt Cont", field: "SALES_GOV_CONT", type: 'rightAligned', cellRendererParams: { align: "right" }, aggFunc: "sum ", cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},
    {headerName: "GST", field: "SALES_SUB_TOTAL_GST", type: 'rightAligned',  cellRendererParams: { align: "right" }, aggFunc: "sum ", cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},
    {headerName: "Hour(Distinct)", field: "HOUR_DISTINCT", minWidth: 190, enableRowGroup: true},
    {headerName: "Item Type", field: "SALES_ITEM_TYPE", enableRowGroup: true},
    {headerName: "Month", field: "MONTH", enableRowGroup: true},
    {headerName: "Sales M/Up?", field: "SALES_MARKUP", type: 'rightAligned', cellRendererParams: { align: "right" }, cellRendererSelector: (_) => {
        return { component: "percentCellRenderer" }
    }},
    {headerName: "Staff", field: "SALES_STAFF", enableRowGroup: true, flex: 2, minWidth:250},
    {headerName: "Status", field: "SALES_STATUS", enableRowGroup: true},
    {headerName: "Surcharge", field: "SALES_SURCHARGE", type: 'rightAligned',  cellRendererParams: { align: "right" }, aggFunc: "sum ", cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},
    {headerName: "Year", field: "YEAR",  type: 'rightAligned' },
    {headerName: "Date", field: "SALES_DATE", minWidth: 190, enableRowGroup: true, cellRenderer: "dateCellRenderer"},
    {headerName: "Total Discount", field: "SALES_TOTAL_DISCOUNT", type: 'rightAligned', cellRendererParams: { align: "right" }, aggFunc: "sum ", cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},
    {headerName: "Hour", field: "HOUR", enableRowGroup: true},
    {headerName: "Register", field: "SALES_REGISTER", type: 'rightAligned', cellRendererParams: { align: "right"}, enableRowGroup: true},   
    {headerName: "Sales GP%", field: "SALES_MARGIN", type: 'rightAligned',  cellRendererParams: { align: "right" }, cellRendererSelector: (_) => {
        return { component: "percentCellRenderer" }
    }},
    {headerName: "Sales Val", field: "SALES_VALUE", type: 'rightAligned', cellRendererParams: { align: "right" }, aggFunc: "sum ", cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},
    {headerName: "Stock Cost", field: "SALES_STOCK_COST",  type: 'rightAligned', cellRendererParams: { align: "right" }, aggFunc: "sum ", cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},
    {headerName: "Subtotal", field: "SALES_SUB_TOTAL", type: 'rightAligned',  cellRendererParams: { align: "right" }, aggFunc: "sum ", cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},
    {headerName: "Stock Avg Cost", field: "SALES_STOCK_AVG_COST", type: 'rightAligned',  cellRendererParams: { align: "right" }, aggFunc: "sum ", cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},
    {headerName: "Sales Val Ex", field: "SALES_VALUE_EX", type: 'rightAligned', cellRendererParams: { align: "right" }, aggFunc: "sum ", cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},
    {headerName: "Promo Discount", field: "SALES_PROMO_DISCOUNT", type: 'rightAligned', cellRendererParams: { align: "right" }, aggFunc: "sum ", cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},
    {headerName: "Qty Sold", field: "SALES_QTY", type: 'rightAligned', aggFunc: "sum "},
    {headerName: "Promo Desc", field: "SALES_PROMO_DESC", flex:2, enableRowGroup: true},
    {headerName: "Payments (Amounts)", field: "SALES_PAYMENTS_WITH_AMOUNTS", enableRowGroup: true, flex: 2, minWidth:210},
    {headerName: "Payments Surcharge", field: "SALES_PAY_METHOD_SURCHARGE", type: 'rightAligned', cellRendererParams: { align: "right" }, aggFunc: "sum ", cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},
    {headerName: "Payments", field: "SALES_PAYMENTS", enableRowGroup: true, flex: 2, minWidth:210},
    {headerName: "Original Price", field: "SALES_ORIGINAL_PRICE", type: 'rightAligned', cellRendererParams: { align: "right" }, aggFunc: "sum ", cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},
    {headerName: "Price Change Reason", field: "SALES_PRICE_CHANGE_REASON", flex: 2, minWidth:300, cellRendererParams: { align: "right"}, enableRowGroup: true},
    {headerName: "Month (Distinct)", field: "MONTH_DISTINCT", enableRowGroup: true},
    {headerName: "Receipts (Group)", field: "SALES_RECEIPT_COUNT", type: 'rightAligned'},
    {headerName: "Receipt No", field: "SALES_RECEIPT_NO", type: 'rightAligned'},
    {headerName: "Sell Price", field: "SALES_SELL_PRICE", type: 'rightAligned', cellRendererParams: { align: "right" }, aggFunc: "sum ", cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},
    {headerName: "Sales GP$", field: "SALES_GP", type: 'rightAligned', cellRendererParams: { align: "right" }, aggFunc: params => {}, cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},
    {headerName: "Agency", field: "SALES_AGENCY", enableRowGroup: true},
    {headerName: "Charged Account", field: "SALES_PAYMENT_ACCOUNT", flex: 2, minWidth:300},
    {headerName: "Agency Commission", field: "SALES_AGENCY_COMMISSION", type: 'rightAligned'},
    {headerName: "Items (Group)", field: "ITEM_COUNT", sortable: false}
]

export const salesReportGridOptions: GridOptions = {
    columnDefs: salesHeaders,
    defaultColDef: {
        flex: 1,

    },
    getChildCount: (data: any) => {
        return data.ROW_COUNT;
    }
}